import { Tag, TagProps, Tooltip } from "@chakra-ui/react";
import React from "react";

type DisqualifiedBadgeProps = {
  unmetRequirementsCount?: number;
  size?: "sm" | "md" | "lg";
  variant?: "solid" | "outline" | "subtle";
} & TagProps;

const DisqualifiedBadge: React.FC<DisqualifiedBadgeProps> = ({
  unmetRequirementsCount,
  size = "sm",
  variant = "solid",
  ...props
}) => {
  return (
    <Tooltip
      label={`${unmetRequirementsCount ?? 0} qualification(s) not met`}
      placement="top"
      isDisabled={unmetRequirementsCount === undefined}
    >
      <Tag
        bg="yellow.100"
        color="yellow.700"
        variant={variant}
        size={size}
        {...props}
      >
        DOES NOT QUALIFY
      </Tag>
    </Tooltip>
  );
};

export default DisqualifiedBadge;
